if (!customElements.get('hydros-cart-discount')) {
  customElements.define('hydros-cart-discount', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-discount-form]');
      this.input = this.querySelector('[data-discount-input]');
      this.button = this.querySelector('[data-discount-apply]');
      this.status = this.querySelector('[data-discount-status]');
      this.onSubmit = (event) => { event.preventDefault(); event.stopPropagation(); this.apply(); };
      this.onRemove = (event) => {
        const button = event.target.closest('[data-discount-remove]');
        if (button) { event.preventDefault(); this.apply(button.dataset.discountRemove); }
      };
      this.form.addEventListener('submit', this.onSubmit);
      this.addEventListener('click', this.onRemove);
    }
    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit);
      this.removeEventListener('click', this.onRemove);
    }
    message(text, error = false) {
      this.status.textContent = text;
      this.status.hidden = !text;
      this.status.classList.toggle('is-error', error);
      if (error) this.input.setAttribute('aria-invalid', 'true');
      else this.input.removeAttribute('aria-invalid');
    }
    codes(codes) {
      const list = this.querySelector('[data-discount-codes]');
      list.replaceChildren();
      for (const entry of codes.filter((entry) => entry.applicable)) {
        const item = document.createElement('li');
        const label = document.createElement('span');
        label.textContent = entry.code;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.dataset.discountRemove = entry.code;
        remove.setAttribute('aria-label', `${this.dataset.removeLabel} ${entry.code}`);
        remove.textContent = '×';
        item.append(label, remove);
        list.append(item);
      }
    }
    async apply(removeCode) {
      if (this.pending) return;
      const code = this.input.value.trim();
      if (!removeCode && !code) { this.message(this.dataset.empty, true); this.input.focus(); return; }
      const drawer = this.closest('cart-drawer');
      if (!drawer) return;
      this.pending = true;
      const controls = [...drawer.querySelectorAll('button,input,select')].filter((element) => !element.classList.contains('drawer__close'));
      const previous = controls.map((element) => [element, element.disabled]);
      controls.forEach((element) => { element.disabled = true; });
      this.button.setAttribute('aria-busy', 'true');
      const label = this.button.textContent;
      this.button.textContent = this.dataset.pending;
      this.message('');
      let updated = false;
      try {
        const currentResponse = await fetch(`${window.routes.cart_url}.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!currentResponse.ok) throw new Error('read');
        const current = await currentResponse.json();
        const existing = (current.discount_codes || []).filter((entry) => entry.applicable).map((entry) => entry.code);
        const requested = removeCode
          ? existing.filter((entry) => entry.toLowerCase() !== removeCode.toLowerCase())
          : [...existing.filter((entry) => entry.toLowerCase() !== code.toLowerCase()), code];
        const sections = drawer.getSectionsToRender().map((section) => section.id);
        const response = await fetch(window.routes.cart_update_url, {
          ...fetchConfig(), credentials: 'same-origin',
          body: JSON.stringify({ discount: requested.join(','), sections, sections_url: window.location.pathname }),
        });
        if (!response.ok) throw new Error('update');
        const data = await response.json();
        if (data.status) throw new Error('update');
        updated = true;
        if (!sections.every((key) => typeof data.sections?.[key] === 'string' && data.sections[key].trim())) {
          window.location.assign(window.routes.cart_url);
          return;
        }
        const entry = (data.discount_codes || []).find((entry) => entry.code.toLowerCase() === code.toLowerCase());
        const accepted = removeCode || entry?.applicable === true;
        if (window.location.pathname.replace(/\/$/, '') === window.routes.cart_url.replace(/\/$/, '')) {
          window.location.assign(window.routes.cart_url);
          return;
        }
        if (!drawer.classList.contains('active')) return;
        if (!drawer.activeElement?.isConnected || drawer.contains(drawer.activeElement)) drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
        drawer.renderContents(data);
        const replacement = drawer.querySelector('hydros-cart-discount');
        if (!replacement) { window.location.assign(window.routes.cart_url); return; }
        replacement.codes(data.discount_codes || []);
        let message = removeCode ? this.dataset.removed : accepted ? this.dataset.success : this.dataset.invalid;
        if (!removeCode && accepted && data.total_price === current.total_price) message = this.dataset.shipping;
        replacement.message(message, !accepted);
        if (!accepted) replacement.input.value = code;
        trapFocus(drawer.querySelector('#CartDrawer'), replacement.input);
      } catch (error) {
        if (updated) { window.location.assign(window.routes.cart_url); return; }
        this.message(this.dataset.error, true);
      } finally {
        this.pending = false;
        for (const [element, disabled] of previous) if (element.isConnected) element.disabled = disabled;
        this.button.removeAttribute('aria-busy');
        this.button.textContent = label;
        if (this.isConnected && this.input.getAttribute('aria-invalid') === 'true') this.input.focus();
      }
    }
  });
}
